import React from 'react';
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { FileFolderCountType } from '../../../redux/listing/listingTypes';

type AppProps = {
  tableHeaders: TableHeadersType[];
 data:[] | FileFolderCountType[]
}

const FileFolderTableData = ({
  tableHeaders,
  data
}: AppProps) => {


  return(
    <>
    {data?.map((dataItem: any) => {
      return<tr>
        {tableHeaders?.length && tableHeaders?.map((item: any) => {
          
          if (dataItem[item.value]) {
          return <td className='text-left'> {dataItem[item.value]}</td>
        }

          else if (dataItem[item.value]==null) {
          return <td className='text-left text-danger'>0</td>
        }

          else{
              return <td> --/-- </td>
          }
        })}
      </tr>
  })}
    
    </>
    )
};

export default FileFolderTableData;